import React from 'react';
import {DashboardCardProps, FavoritesList} from '..';
import {BaseLineItems} from './BaseLineItems';
import {Stack, useTheme} from '@fluentui/react';
import {getListClassNames} from 'styles';

export const WorkbenchBaselineList: React.FC<DashboardCardProps> = ({
	halfHeight = false,
	itemCountLoaded,
}) => {
	const theme = useTheme();
	const classNames = getListClassNames(theme, halfHeight);
	return (
		<>
			<Stack.Item grow={1} basis={0}>
				<div className={classNames.dashboardActivityContainer}>
					<BaseLineItems halfHeight itemCountLoaded={itemCountLoaded} />
				</div>
			</Stack.Item>
			<Stack.Item grow={1} basis={0}>
				<FavoritesList
					halfHeight
					className={classNames.dashboardActivityContainer}
				/>
			</Stack.Item>
		</>
	);
};
